var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-container"},[_c('transition-group',{attrs:{"name":"message"}},_vm._l((_vm.messages),function(msg){return _c('message-item',{key:msg.id,attrs:{"msg":msg},on:{"close":function($event){return _vm.closeMessage(msg.id)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }